module.exports = __webpack_public_path__ + "static/media/three-a-of-testing.eb398590.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/expect-more/assets/three-a-of-testing.png
// module id = 670
// module chunks = 0